import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'

import type { AddToListRequest } from '../types'

interface Props {
  selectedItems: AddToListRequest['itemIds']
  onAdd: () => void
  title: string
  description: string
  mediaType: AddToListRequest['mediaType']
}

export const AddToList = ({
  selectedItems,
  onAdd,
  title,
  description,
  mediaType,
}: Props) => {
  const addToTikTokListDialog = () => {
    openDialog({
      type: DIALOG_TYPE.ADD_TO_TIKTOK_LIST_DIALOG,
      selectedItems,
      onAdd,
      title,
      description,
      mediaType,
    })
  }

  return (
    !!selectedItems.length && (
      <Button
        className="fixed bottom-10 left-1/2 -translate-x-1/2 lg:left-[calc(150px+50%)]"
        onClick={addToTikTokListDialog}
      >
        <PlusIcon />
        Add to List
      </Button>
    )
  )
}
